import { defineComponent as _defineComponent } from 'vue'
import LogoPoweredByGala from '~/components/UIComponents/LogoPoweredByGala.vue';
import LogoGalaFilm from '~/components/UIComponents/LogoGalaFilm.vue';
import { TSanityBlockContent as TSanityContentComponentBlockContent } from '~/types/sanity';
import { TSanityBlockContent } from '~/types/sanity-objects';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoBoxExplainer',
  props: {
    body: null,
    ctaDisabled: { type: Boolean },
    ctaText: null,
    heading: null,
    image: null,
    imageAlt: null,
    listItems: null,
    overline: null,
    title: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, LogoPoweredByGala, LogoGalaFilm }
}

})